<template>
  <portal to="modal">
    <transition name="modal">
      <div class="modal__outer" @click.self="$emit('close')">
        <div class="modal__inner">
          <button class="modal__close" @click="$emit('close')">
            <i class="fa fa-close"></i>
          </button>
          <div class="modal__content">
            <slot></slot>
          </div>
        </div>
      </div>
    </transition>
  </portal>
</template>

<script>
export default {
  name: "Modal",

  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  }
};
</script>
